<template>
  <div class="hr-short-answer-questions">
    <div class="__title-container">
      <div v-if="title" class="__title">
        {{ title }}
        <sup class="__required-suffix">
          {{ suffix }}
        </sup>
      </div>
      <p v-html="helper" class="__helper"></p>
    </div>
    <hr-co-input
      :value="state.answer"
      :invalid="state.field?.isInvalid"
      :errorMessage="state.field?.fieldError"
      :max="MAX_LENGTH"
      :masked="state.masked"
      @input="changeInput"
      @blur="(value) => (state.answer = value?.trim())"
    >
      <template v-slot:invalid class="HRField__invalid">{{
        state.field?.fieldError
      }}</template>
    </hr-co-input>
  </div>
</template>

<script>
import HrCoInput from './hr-co-input';
import { reactive, computed } from 'vue';
import { validateShortAnswer } from '@/core/validation/common/custom-questions';
import { enableMask } from '@/core/fields-to-mask.js';

const MAX_LENGTH = 100;

export default {
  name: 'hr-short-answer-questions',
  components: { HrCoInput },
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['update:model-value'],
  setup(props, { emit }) {
    const state = reactive({
      field: computed(() => props.modelValue),
      answer: computed({
        get: () =>
          (state.field?.questionValue?.responses[0] || {}).answer || '',
        set: updateInputFields,
      }),
      masked: enableMask(props.modelValue),
    });

    const helper = state.field?.questionValue?.description;
    const suffix = state.field?.questionValue?.isRequired ? '*' : '';
    const title = state.field?.questionValue?.question;

    function updateInputFields(value) {
      // Only cater for one response for short answer type questions.
      const responses = [{ answer: value }];
      state.field.questionValue.responses = responses;
      state.field.value = state.field?.questionValue;

      state.field.fieldError = validateShortAnswer(state.field);
      if (state.field.fieldError) {
        state.field.isInvalid = true;
      }
      input();
    }

    function input() {
      emit('update:model-value', state.field);
    }

    function changeInput() {
      state.field.isInvalid = false;
    }

    return {
      state,
      helper,
      suffix,
      title,
      changeInput,
      MAX_LENGTH,
    };
  },
};
</script>

<style scoped>
.hr-short-answer-questions {
  margin-bottom: 32px;
}

.__title {
  font-weight: 600;
  color: var(--co-text-primary);
  margin-bottom: 4px;
}

.__required-suffix {
  font-weight: 600;
  left: -0.3em;
  color: var(--co-text-primary);
}

.__helper {
  font-size: 14px;
  color: var(--co-text-secondary);
  font-weight: 400;
}

@media only screen and (max-width: 768px) {
  .hr-short-answer-questions,
  .__helper {
    font-size: 16px;
  }
}
</style>
